$('.profile-image').children('p').each(function () {
  if ($(this).is(':empty'))
      $(this).parent().addClass('img-block-no-quote');      
})
